import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Manual Routes and Pages
 */
const ListBrochurePage = React.lazy(() => import("./ListBrochurePage"));
const AddBrochurePage = React.lazy(() => import("./AddBrochurePage.js"));
const EditBrochurePage = React.lazy(() => import("./EditBrochurePage"));

const BrochureRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListBrochurePage />} />
      <Route exact path="/add" element={<AddBrochurePage />} />
      <Route exact path="/edit/:id" element={<EditBrochurePage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default BrochureRoutes;
